import {X} from 'lucide-react';
import * as React from 'react';

/**
 * Dashed "add" affordance for a contextual attachment source (the create
 * modal's "+ Benefit" / "+ Fee period"). Rendered inline among the strip's
 * pills; clicks stop propagating so the strip's click-to-focus doesn't steal
 * focus from whatever the chip opens.
 */
export const AttachmentGhostChip = React.forwardRef(
  (
    props: {
      icon: React.ReactNode;
      label: string;
      onClick: () => void;
    },
    ref: React.Ref<HTMLButtonElement>,
  ) => (
    <button
      ref={ref}
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        props.onClick();
      }}
      className="border-input text-muted-foreground hover:border-ring hover:text-foreground inline-flex h-6 shrink-0 cursor-pointer items-center gap-1.5 rounded-full border border-dashed px-2.5 text-xs transition"
    >
      <span className="inline-flex [&>svg]:size-3">{props.icon}</span>+{' '}
      {props.label}
    </button>
  ),
);

/**
 * An attached record shown as a pill among the strip's tag/field pills,
 * carrying a short detail (e.g. the benefit's remaining balance) and a
 * remove button. Visually heavier than a tag pill — these do something on
 * submit, and the icon + detail signal that weight.
 */
export const AttachmentPill = (props: {
  icon: React.ReactNode;
  label: string;
  detail?: string;
  onRemove: () => void;
}) => (
  <span className="bg-primary/10 text-primary inline-flex h-6 max-w-full min-w-0 items-center gap-1.5 rounded-full px-2.5 text-xs">
    <span className="inline-flex shrink-0 [&>svg]:size-3">{props.icon}</span>
    <span className="truncate font-medium">{props.label}</span>
    {props.detail && (
      <span className="text-primary/70 shrink-0">{props.detail}</span>
    )}
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        props.onRemove();
      }}
      className="hover:bg-primary/20 ml-0.5 shrink-0 cursor-pointer rounded"
    >
      <X className="h-3 w-3" />
    </button>
  </span>
);
